import { Map } from 'immutable'
import {
  SET_RAINBOW_PROCESSING,
  SET_RAINBOW_ERROR,
  SET_RAINBOW_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_RAINBOW_PROCESSING:
      return state.set('processing', payload.processing)
    case SET_RAINBOW_DATA:
      return state
        .set('data', payload.data)
        .set('processing', payload.processing)
    case SET_RAINBOW_ERROR:
      return state
        .set('error', payload.error)
        .set('processing', payload.processing)
    default:
      return state
  }
}
